<div class="modal position" tabindex="-1">
    <div class="modal-dialog shadow-lg">
        <div class="modal-content">
            <div class="modal-header flex-column">
                <div class="ms-auto">
                    <button (click)="close()" type="button" class="btn-close" aria-label="Close"></button>
                </div>
            </div>
            <div class="modal-body modal--max-width p-3 p-lg-5">
                <h3 class="modal-title fw-bold text-center mb-3">
                    {{data.title}}
                </h3>
                <div class="w-100 ff-spectral" [innerHTML]="data.descriptionHTML"></div>
            </div>
            <div *ngIf="this.showFooterPopup">
                <div *ngIf="!data.singleButton; else singleButton" class="modal-footer modal--max-width justify-content-between px-3 px-lg-5">
                    <button (click)="cancel()" type="button" class="btn btn-outline-primary">Cancel</button>
                    <button (click)="confirm()" type="button" class="btn btn-primary">{{data.buttonText ? data.buttonText : 'Yes, delete'}}</button>
                </div>
                <ng-template #singleButton>
                    <div class="modal-footer modal--max-width justify-content-center px-3 px-lg-5">
                        <button (click)="cancel()" type="button" class="btn btn-outline-primary">{{data.buttonText}}</button>
                    </div>
                </ng-template>

            </div>
            
        </div>
    </div>
</div>
